import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import VerifyTransactionMatchesView from '../../components/financial/VerifyTransactionMatchesView';
import {} from // buildCombinedTransactionModels,
// matchTransactionsToConnections,
'../../../utils/bankAccountUtil';
import { BankTransaction, BankTransactionWithParticipation } from '../../../types/bankAccount';
import * as bankAccountService from '../../../services/bankAccountService';
import PageHeader from '../../components/misc/PageHeader';
import { RootState } from '../../../redux/reducers';
import { Connection } from '../../../redux/slices/connectionsSlice';
import HandleUnmatchedTransactionsView from '../../components/financial/HandleUnmatchedTransactionsView';

export default function BulkSplittingPage(): JSX.Element {
  const { t } = useTranslation('');

  const [transactions, setTransactions] = useState<
    BankTransactionWithParticipation[] | null | undefined
  >();
  const [confirmedMatches, setConfirmedMatches] = useState<
    { transaction: BankTransaction; matchedConnection: Connection }[] | null
  >(null);

  const connections = useSelector((state: RootState) => state.connections);

  useEffect(() => {
    // TODO
    // bankAccountService.getBankAccountWithTransactions().then((account) => {
    //   if (account) {
    //     setTransactions(account.transactions);
    //   }
    // });
  }, []);

  return (
    // <div className="flex flex-col">
    //   <PageHeader title={t('title')} />
    //   {transactions === null && <h2>No bank account</h2>}
    //   {transactions === undefined && <h2>Loading...</h2>}
    //   {transactions && transactions.length === 0 && <h2>No transactions to split</h2>}
    //   {transactions && !confirmedMatches && (
    //     <VerifyTransactionMatchesView
    //       matches={matchTransactionsToConnections(transactions, connections)}
    //       onConfirm={(confirmedMatchesFromUser) => {
    //         setConfirmedMatches(
    //           confirmedMatchesFromUser as {
    //             transaction: BankTransaction;
    //             matchedConnection: Connection;
    //           }[],
    //         );
    //         const confirmedTransactions = confirmedMatchesFromUser.map(
    //           (match) => match.transaction.tra,
    //         );
    //         setTransactions(
    //           transactions.filter((tns) => !confirmedTransactions.includes(tns.sequenceNumber)),
    //         );
    //       }}
    //     />
    //   )}
    //   {transactions && confirmedMatches && (
    //     <HandleUnmatchedTransactionsView
    //       unmatched={transactions}
    //       onConfirm={(splitTransactions) => {
    //         const combined = buildCombinedTransactionModels(
    //           [],
    //           confirmedMatches,
    //           splitTransactions,
    //           connections,
    //         );
    //
    //         Promise.allSettled(
    //           combined.map((ts) =>
    //             // FIXME: This should be a bulk operation
    //             // FIXME: This should not be a sequence number, but a transaction ID
    //             bankAccountService.updateBankTransaction(ts., ts),
    //           ),
    //         ).then(() => {
    //           toast.success(t('success.importBankTransactions'));
    //         });
    //       }}
    //     />
    //   )}
    // </div>
    <div>WIP</div>
  );
}
